<template>
  <div id="app" class="app" :style="{'width': `${this.appWidth}px`}">
    <!--  页头  -->
    <Header v-show="$route.meta.show_header"/>

    <!--  路由视图  -->
    <keep-alive :include="['home','about', 'certificate', 'project', 'product']">
      <router-view/>
    </keep-alive>

    <!--  页尾  -->
    <Footer v-show="$route.meta.show_footer"/>

    <!--  回到顶部  -->
    <Backup/>

    <!--  联系方式  -->
    <SuspensionBox/>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Backup from '@/components/Backup'
import throttle from "lodash/throttle";

export default {
  name: 'App',
  components: {Header, Footer, Backup},
  data() {
    return {
      minWidth: 1500,
      appWidth: 1500,
      browserWidth: document.body.clientWidth - 17,
    }
  },
  computed: {},
  methods: {},
  watch: {
    // 监听窗口宽度并修改app宽度
    browserWidth: {
      handler(val) {
        if (val > this.minWidth) {
          this.appWidth = val
        } else {
          this.appWidth = this.minWidth
        }
      },
      immediate: true
    },
  },
  mounted() {
    // 监听窗口大小
    window.onresize = throttle(() => {
      return (() => {
        this.browserWidth = document.body.clientWidth
      })()
    }, 500)
  }
}
</script>

<style scoped lang="less">
.app {

}
</style>

<style lang="less">
/* 版心 */
.container {
  margin: 0 auto;
  width: 1200px;
}

.search-box {
  display: flex;
  justify-content: center;

  div {
    height: 38px;
    width: 260px;
    border: 1px solid #DDDDDD;

    input {
      width: 100%;
      height: 100%;
      color: #666;
      font-size: 14px;
      background: none;
      outline: none;
      border: none;

      &::-webkit-input-placeholder {
        font-size: 14px;
        color: #CCCCCC;
      }
    }
  }

  button {
    width: 60px;
    height: 40px;
    font-size: 20px;
    color: white;
    background-color: #1E50AE;
    cursor: pointer;
    border: none;
    outline: none;
  }
}

.top-img {
  width: 100%;
  height: 300px;
  overflow: hidden;
}

</style>

<style lang="less">
img[lazy="loading"] {
  width: 250px !important;
  height: 250px !important;
}
</style>
